import { useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import momentTz from 'moment-timezone';
import { Overflow } from 'ui/icons';
import { Menu } from 'ui/menu';
import { ALIGNMENT } from 'ui/menu/constants';
import { IconButton, BUTTON_VARIANTS } from 'ui/button';
import { Skeleton } from 'ui/skeleton';
import { getChartExportingOptions, getChartActions } from 'modules/productAnalytics/utils';
import { StyledDivider } from 'modules/productAnalytics/Styled';
import { CampaignAnalyticsCardTimeSeriesHeader, SkeletonWrapper } from './Styled';
import { graphColorPalette } from '../constants';

if (typeof Highcharts === 'object') {
  HighchartsExporting(Highcharts);
  HighchartsExportData(Highcharts);
}

export const TimeSeriesChart = ({ data, isLoading, id, timezone }) => {
  const chart = useRef();
  const zone = momentTz.tz(timezone);
  const offset = zone.utcOffset();
  const overflowActions = getChartActions(id, chart);

  const exportingOptions = getChartExportingOptions(id);

  const options = {
    chart: {
      type: 'line',
      spacingTop: 30,
      spacingBottom: 20,
    },
    time: {
      timezoneOffset: offset * -1,
    },
    title: {
      text: undefined,
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      x: 0,
      y: -20,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    colors: graphColorPalette,
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        minute: '%l:%M%P',
        hour: '%l:%M%P', // 1:05pm
        day: '%b %e', // June 6
      },
    },
    yAxis: {
      lineWidth: 1,
      type: 'linear',
      gridLineDashStyle: 'ShortDash',
      gridLineWidth: 1,
    },
    series: data,
  };
  return (
    <>
      <CampaignAnalyticsCardTimeSeriesHeader>
        <Menu
          handleSelectionChange={(key) => key && overflowActions[key]()}
          horizontalAlignment={ALIGNMENT.RIGHT}
          options={exportingOptions}
        >
          <IconButton variant={BUTTON_VARIANTS.SECONDARY}>
            <Overflow />
          </IconButton>
        </Menu>
      </CampaignAnalyticsCardTimeSeriesHeader>
      <StyledDivider />
      {isLoading ? (
        <SkeletonWrapper height={300} padding={24}>
          <Skeleton />
        </SkeletonWrapper>
      ) : (
        <HighchartsReact
          ref={chart}
          options={options}
          containerProps={{ style: { width: '100%', padding: '24px' } }}
        />
      )}
    </>
  );
};
